import type { SearchHit } from '@tf/shared';
import { getResultHit, ScreeningResultCard } from '@tf/shared';
import { Box, createStyles, Group, lighten, Modal, Stack, TFText, useDisclosure } from '@tf/ui';
import type React from 'react';

const useStyles = createStyles(({ colors, radius }) => ({
	infoBlockWrapper: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '.75rem .75rem',
		borderRadius: radius.sm,
		backgroundColor: colors.gray[1],
		cursor: 'pointer',
	},
	infoBlockToggleWrapper: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '.75rem .75rem',
		borderRadius: radius.sm,
		backgroundColor: colors.gray[1],
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: lighten(colors.brand[1], 0.5),
		},
	},
	infoBlockContent: {
		flex: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		marginRight: '.5rem',
		color: colors.dark[4],
	},
	infoBlockText: {
		maxWidth: '500px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	chevron: {
		color: colors.brand[6],
		padding: '.05rem',
		borderRadius: '50%',
	},
	chevronWrapper: {
		fontWeight: 600,
	},
}));

interface Props {
	hit?: SearchHit;
}

export const JobResultCard: React.FC<Props> = ({ hit }) => {
	const { classes } = useStyles();

	const infoModal = useDisclosure();

	if (!hit) return null;

	return (
		<Stack gap="md">
			<Box className={classes.infoBlockToggleWrapper} onClick={infoModal.open}>
				<Group p="apart" className={classes.infoBlockContent}>
					<TFText size="sm" className={classes.infoBlockText}>
						Match: {hit.doc?.name}
					</TFText>
					<Group className={classes.chevronWrapper}>
						<TFText
							size="sm"
							sx={({ colors }) => ({
								color: colors.brand[7],
							})}
						>
							Show details
						</TFText>
					</Group>
				</Group>
			</Box>
			<Modal size="xl" opened={infoModal.isOpen} title={hit.doc?.name} onClose={infoModal.close}>
				<Box p="0.75rem">
					<ScreeningResultCard withInnerCard={false} hit={getResultHit(hit)} />
				</Box>
			</Modal>
		</Stack>
	);
};
